module.exports = "<svg id=\"f5ba75a5-4a37-4239-b85f-98cfe19bf531\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow</title><path d=\"M35.91,44.81,22.37,27.89h.1L20.1,25l2.33-2.87h-.07L35.91,5.21a3.06,3.06,0,0,0-.45-4.05,2.89,2.89,0,0,0-4.05.45L14.13,23.21A2.63,2.63,0,0,0,13.5,25h0a4.25,4.25,0,0,0,.63,1.8l17.28,21.6a2.9,2.9,0,0,0,4,.45A3,3,0,0,0,35.91,44.81Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.svg
// module id = 7Hhe
// module chunks = 1